/**
 * role-menu.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import useRecordStore from 'contexts/record-store';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import BarButton from '../bar-button';


const useStyles = makeStyles(theme => ({
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: theme.spacing(1),
  },
  role: {
    fontSize: theme.typography.overline.fontSize,
    textTransform: 'uppercase',
    color: theme.palette.comp.navBar.onSurfaceVariant,
    letterSpacing: '0.1em',
    marginRight: '-2px',
  },
  roleName: {
    fontSize: theme.typography.sizes[2],
  },
}));


export default function RoleMenu(props) {
  const classes = useStyles();
  const location = useLocation();
  const { user, setRole } = React.useContext(UserContext); 
  const recordStore = useRecordStore();
  const status = recordStore.useStatus();
  const isInitializing = status.isInitializing.get();
  const isRecordsPage = location.pathname.startsWith('/records');


  const updateRole = (role) => {
    if (user.role.id !== role.id) {
      setRole(role);
    }    
  }


  return (
    <>
      {user.availableRoles.length > 1 &&
      <DropMenu
        id="change-role"
        label={(
          <BarButton wide data-testid='role-menu-button' disabled={isRecordsPage && isInitializing}>
            <div className={classes.text} data-testid="role-container-desktop">
              <div className={classes.role}>Role</div>
              <div className={classes.roleName}>{user.role.name}</div>
            </div>  
            <Icon type='role' />
          </BarButton>
        )}
        aria-label="change role menu"
        onSelect={updateRole}
        items={user.availableRoles.map(role => ({
            ...role,
            key: role.id,
            icon: role.name.toLowerCase(),
            active: user.role.id === role.id,
          }))}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      />}
    </>
  );
}